module.exports = __webpack_public_path__ + "static/img/right-home-row-6.65288a82.webp";